import React from "react"
import {
  DeliveredOperation,
  Operation,
  OperationWrapper,
  PlacedOperation,
  RefundedOperation,
  ReleasedOperation
} from "./OrderLine.styled"
import {
  Order,
  OrderGiftCardProductItemRetain24,
  OrderHistory
} from "lib/types/generated/graphql-types"
import { OrderHistoryOperations } from "../../../classes/order/OrderHistoryOperations"
import { Cancellations } from "../../../classes/order/Cancellations"

type Props = {
  giftCardProductLine: OrderGiftCardProductItemRetain24
  compensationTotal: number
  orderHistory: OrderHistory
  order: Order
}

const OrderLineOperations = ({
  giftCardProductLine,
  compensationTotal,
  orderHistory,
  order
}: Props) => {
  const orderOperations = new OrderHistoryOperations(orderHistory?.operations)
  const cancellation = new Cancellations(order.Cancellations)

  const deliveredGiftCardProduct = orderOperations.getDeliveredGiftCardProduct(
    giftCardProductLine.id
  )
  const refundedGiftCardProduct = orderOperations.getRefundedGiftCardProduct(giftCardProductLine.id)
  const releasedGiftCardProduct = orderOperations.getReleasedGiftCardProduct(giftCardProductLine.id)

  const cancelledOrder = cancellation.orderCancelled(order.id)

  const getOperation = () => {
    if (refundedGiftCardProduct) return <RefundedOperation>Returned</RefundedOperation>
    if (deliveredGiftCardProduct) return <DeliveredOperation>Delivered</DeliveredOperation>

    if (releasedGiftCardProduct) return <ReleasedOperation>Released</ReleasedOperation>
    if (cancelledOrder) return <RefundedOperation>Cancelled</RefundedOperation>
    return <PlacedOperation>Placed</PlacedOperation>
  }

  return (
    <OperationWrapper>
      <div>
        {compensationTotal > 0 && <Operation>Compensated</Operation>}
        <Operation>Gift card</Operation>
      </div>
      <div>{getOperation()}</div>
    </OperationWrapper>
  )
}

export default OrderLineOperations
